export default "__VITE_ASSET__sm82yadf__"